import React from "react";

// Utility function to join class names
function cn(...classes) {
  return classes.filter(Boolean).join(" ");
}

// Default Tailwind styles
const defaultButtonVariants = {
  variant: {
    default:
      "w-full rounded-[10px] bg-blue text-white font-semibold transition duration-300 ease-in-out hover:bg-purple-300 hover:shadow-lg",
    customGray: "w-full h-[53px] text-size-14 font-semibold text-[#727484] bg-[#EFEFEF] hover:bg-[#e0e0e0] rounded-[10px] border border-[var(--Grey-100,#D6D8E5)]",
    customBlue: "w-full h-[49px] rounded-[10px] bg-blue text-white text-size-14 font-semibold transition duration-300 ease-in-out hover:bg-purple-300 hover:shadow-lg",
    destructive:
      "bg-red-600 text-white shadow-sm hover:bg-red-700 focus-visible:ring-2 focus-visible:ring-red-300 dark:focus-visible:ring-red-500 dark:bg-red-500",
    outline:
      "h-[48px] w-full rounded-[10px] bg-white border border-purple-100 text-black text-[14px] font-semibold flex justify-center items-center gap-2",
    secondary:
      "bg-gray-100 text-gray-800 shadow-sm hover:bg-gray-200",
    ghost:
      "hover:bg-gray-100 hover:text-black dark:hover:bg-gray-700",
    link:
      "text-blue-600 underline underline-offset-4 hover:text-blue-800",
  },
  size: {
    default: "h-[49px]",
    sm: "h-8 rounded-md gap-1.5 px-3",
    lg: "h-10 rounded-md px-6",
    icon: "w-9 h-9 flex items-center justify-center",
  },
};

// Combines styles based on domain
function getButtonClasses({ variant = "default", size = "default", className }) {
  const variants =defaultButtonVariants;

  return cn(
    variants.variant[variant] || variants.variant.default,
    variants.size[size] || variants.size.default,
    className
  );
}

// Reusable Button component
function Button({ className, variant, size, children, ...props }) {
  return (
    <button
      type="button"
      className={getButtonClasses({ variant, size, className })}
      {...props}
    >
      {children}
    </button>
  );
}

export { Button };
